export var MarketTypes;
(function (MarketTypes) {
    MarketTypes["outright"] = "OutRight";
})(MarketTypes || (MarketTypes = {}));
//# sourceMappingURL=MarketTypes.js.map